module.exports = __webpack_public_path__ + "img/handwriting@1x.440a9bc6.png";